import React from "react";
import styles from "./ProjectsComponent.module.css";

const ProjectsComponent = () => {
  const projects = [
    {
      title: "Automate Internal Operations",
      description: 
        "Struggling with manual data updates? This custom Salesforce portal allows employees to update records, apply for jobs with one click, and manage requests in real time. The result? Faster processes and fewer administrative bottlenecks.",
      link: "#",
      tech: ["Salesforce", "Apex", "LWC", "Digital Experience", "CMS"],
    },
    {
      title: "Real-Time Insights for Better Sales Decisions",
      description: 
        "Managing leads across multiple platforms can be overwhelming. I developed a reporting system that integrates data from multiple sources into a live dashboard. Businesses now get real-time insights on their best lead sources, improving decision-making and conversions.",
      link: "#",
      tech: ["Google Apps Script", "Google Sheets", "HTML", "CSS", "JavaScript"],
    },    
    {
      title: "Simplify Finance & Client Management",
      description: 
        "Many contractors spend hours managing finances manually. This web app streamlines invoicing, expense tracking, and client management, freeing up time for more work while keeping finances in order.",
      link: "#",
      tech: ["PostgreSQL", "FastAPI", "Next.js", "React"], 
    }    
  ];

  return (
    <section className={styles.projects}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Solutions That Drive Results</h2>
        <p className={styles.sectionSubtitle}>
          I specialize in automation, CRM solutions, and web applications that help businesses save time, improve workflows, and increase revenue. Here are a few of my recent projects:
        </p>
        <div className={styles.projectsGrid}>
          {projects.map((project, index) => (
            <div className={styles.projectCard} key={index}>
              <h3 className={styles.projectTitle}>{project.title}</h3>
              <p className={styles.projectDescription}>{project.description}</p>
              <ul className={styles.projectTech}>
                {project.tech.map((tech, index) => (
                  <li key={index} className={styles.techItem}>{tech}</li>
                ))}
              </ul>
              {/* <a href={project.link} className={styles.projectLink}>View Project</a> */}
            </div>
          ))}
        </div>
        <div className={styles.buttonContainer}>
          {/* <button
            className={styles.viewAllButton}
            onClick={() => window.location.href = "/projects"}
          >
            See More Success Stories
          </button> */}
          <button
            className={styles.viewAllButton}
            onClick={() => window.location.href = "/contact"}
          >
            Get a Free Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProjectsComponent;
